<template>
  <div class="row">
    <div class="co1-2 category-checkbox-category-label flex items-center">
      <label>カテゴリー</label>
    </div>
    <div class="col category-checkbox">
      <q-option-group
        v-model="categoriesComputed"
        :options="reagentOptions"
        color="primary"
        type="checkbox"
        inline
        class="category-med"
      />
      <q-option-group
        v-model="allBulkSelect"
        :options="allBulkOptions"
        color="primary"
        type="checkbox"
        inline
        class="category-allbulk"
      />
      <q-option-group
        v-model="categoriesComputed"
        :options="bulkOptions"
        color="primary"
        type="checkbox"
        inline
        class="category-other"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import http from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface Props {
  // カテゴリー
  categories: Array<number>;
}
const props = defineProps<Props>();

const router = useRouter();

const emit = defineEmits(['change']);

// 試薬
const REAGENT = 1;

// 全体量
const ALL_BULK = 100;

// カテゴリー
const categoriesComputed = computed({
  get: () => props.categories,
  set: (value) => {
    if (value.length !== 0) {
      if (value[0] === REAGENT && value[value.length - 1] !== REAGENT) {
        value.shift();
      } else if (value[0] !== REAGENT && value[value.length - 1] === REAGENT) {
        value.splice(0, value.length - 1);
      }
    }
    emit('change', value);
  },
});

// チェックボックス
interface CheckBoxOption {
  [props: string]: unknown;
  label: string;
  value: unknown;
  disable?: boolean | undefined;
}

// 試薬
const reagentOptions = ref<Array<CheckBoxOption>>([]);
// 大量品
const bulkOptions = ref<Array<CheckBoxOption>>([]);

const allBulkOptions = ref<Array<CheckBoxOption>>([]);

const allBulkSelect = computed({
  get: () => props.categories,
  set: (value) => {
    if (value.length !== 0) {
      if (value[0] === REAGENT && value[value.length - 1] !== REAGENT) {
        value.shift();
      }
    }
    if (value[value.length - 1] === ALL_BULK) {
      for (let i = 0; i < bulkOptions.value.length; i += 1) {
        value.push(Number(bulkOptions.value[i].value));
      }
    } else {
      value.splice(0, value.length);
    }
    emit('change', value);
  },
});

// カテゴリー取得
const getCategories = () => {
  http
    .post('/csr002001/category')
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        // システムエラー
        router.push({ name: 'error' });
      }
      response.data.categoryAllItems.forEach(
        (category: { sup_category_id: number; sup_category: string }) => {
          // 試薬の場合
          if (category.sup_category_id === REAGENT) {
            reagentOptions.value.push({
              value: category.sup_category_id,
              label: category.sup_category,
            });
          } else {
            bulkOptions.value.push({
              value: category.sup_category_id,
              label: category.sup_category,
            });
          }
        }
      );
      allBulkOptions.value.push({
        value: ALL_BULK,
        label: 'バルク一括チェック',
      });
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// 初期表示処理
getCategories();
</script>
<style scoped>
.category-checkbox-category-label {
  font-weight: 600;
  border-right: 3px solid var(--q-primary);
  padding-right: 0.5em;
}
.category-checkbox {
  display: flex;
  flex-direction: column;
  position: relative;
}

.category-med {
  position: absolute;
  top: 0;
  left: 0;
  padding-right: 20px;
}

.category-allbulk {
  position: absolute;
  top: 0;
  left: 100px;
  padding-right: 20px;
}

.csr00200-search-form .q-option-group.category-med:after {
  border-right: 2px solid gray;
  content: '';
  width: 1px;
  height: 24px;
  position: absolute;
  right: 0;
  top: 8px;
}
</style>
<style>
.category-checkbox .category-other > div:first-child {
  margin-left: 280px;
}
</style>
